import { Auth, AuthProvider } from "@/types/ApiResponses/Auth";

export const signInWithSocial = (provider: AuthProvider): Promise<Auth> => {
  throw new Error("Sign in with social not implemented yet");
};
